import { useCrudActions } from '@/common/view/useCrudActions';
import { transactionService } from '@/services/transaction';
import FileSaver from 'file-saver';
import { reactive } from 'vue';

export function useTransactionExport() {
    const crudAction = useCrudActions();

    const model = reactive({
        file: null
    });

    const exportXml = crudAction.excuteAndNotify({
        request: transactionService.text.export,
        onSuccess: ({ data }) => {
            const blob = new Blob([data], { type: 'text/xml;charset=utf-8' });
            FileSaver.saveAs(blob, 'translation.xml');
        }
    });

    const importXml = crudAction.excuteAndNotify({
        canExecute: () => model.file != null,
        request: () => transactionService.text.import(model.file),
        onSuccess: () => (model.file = null)
    });

    return { model, fetch, exportXml, importXml };
}
